import { render, staticRenderFns } from "./MenuInfo.vue?vue&type=template&id=a7d3b132&scoped=true&"
import script from "./MenuInfo.vue?vue&type=script&lang=ts&"
export * from "./MenuInfo.vue?vue&type=script&lang=ts&"
import style0 from "./MenuInfo.vue?vue&type=style&index=0&id=a7d3b132&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a7d3b132",
  null
  
)

export default component.exports